import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, BrowserBackGuard } from 'cbc-shared-lib';
import { Sgke010dComponent } from './pages/sgke010d/pages/sgke010d/sgke010d.component';
import { Sgke020dComponent } from './pages/sgke020d/pages/sgke020d/sgke020d.component';
import { Sgke030dComponent } from './pages/sgke030d/pages/sgke030d/sgke030d.component';
import { Sgke040dComponent } from './pages/sgke040d/pages/sgke040d/sgke040d.component';
import { Sgke050dComponent } from './pages/sgke050d/pages/sgke050d/sgke050d.component';
import { Sgke060dComponent } from './pages/sgke060d/pages/sgke060d/sgke060d.component';
import { Sgke070dComponent } from './pages/sgke070d/pages/sgke070d/sgke070d.component';
import { Sgke080dComponent } from './pages/sgke080d/pages/sgke080d/sgke080d.component';
import { Sgke090dComponent } from './pages/sgke090d/pages/sgke090d/sgke090d.component';
import { Sgke100dComponent } from './pages/sgke100d/pages/sgke100d/sgke100d.component';
import { Sgke110dComponent } from './pages/sgke110d/pages/sgke110d/sgke110d.component';
import { Sgke120dComponent } from './pages/sgke120d/pages/sgke120d/sgke120d.component';
import { Sgke130dComponent } from './pages/sgke130d/pages/sgke130d/sgke130d.component';
import { Sgke140dComponent } from './pages/sgke140d/pages/sgke140d/sgke140d.component';
import { Sgke150dConditionComponent } from './pages/sgke150d/components/sgke150d-condition/sgke150d-condition.component';
import { Sgke150dComponent } from './pages/sgke150d/pages/sgke150d/sgke150d.component';
import { Sgke160dComponent } from './pages/sgke160d/pages/sgke160d/sgke160d.component';
import { Sgke300dComponent } from './pages/sgke300d/pages/sgke300d/sgke300d.component';
import { Sgke310dComponent } from './pages/sgke310d/pages/sgke310d/sgke310d.component';
import { Sgke320dComponent } from './pages/sgke320d/pages/sgke320d/sgke320d.component';
import { Sgke330dComponent } from './pages/sgke330d/pages/sgke330d/sgke330d.component';
import { Sgke340dComponent } from './pages/sgke340d/pages/sgke340d/sgke340d.component';
import { Sgke350dComponent } from './pages/sgke350d/pages/sgke350d/sgke350d.component';
import { Sgke360dComponent } from './pages/sgke360d/pages/sgke360d/sgke360d.component';
import { Sgke370dComponent } from './pages/sgke370d/pages/sgke370d/sgke370d.component';
import { Sgke380dComponent } from './pages/sgke380d/pages/sgke380d/sgke380d.component';
import { Sgke390dComponent } from './pages/sgke390d/pages/sgke390d/sgke390d.component';
import { Sgke400dComponent } from './pages/sgke400d/pages/sgke400d/sgke400d.component';
import { Sgke410dComponent } from './pages/sgke410d/pages/sgke410d/sgke410d.component';


const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    canDeactivate: [BrowserBackGuard],
    children: [
      { path: 'sgke010d', component: Sgke010dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke020d', component: Sgke020dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke030d', component: Sgke030dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke040d', component: Sgke040dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke050d', component: Sgke050dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke060d', component: Sgke060dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke070d', component: Sgke070dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke080d', component: Sgke080dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke090d', component: Sgke090dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke100d', component: Sgke100dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke110d', component: Sgke110dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke120d', component: Sgke120dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke130d', component: Sgke130dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke140d', component: Sgke140dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke150d', component: Sgke150dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke150d-condition', component: Sgke150dConditionComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke160d', component: Sgke160dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke300d', component: Sgke300dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke310d', component: Sgke310dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke320d', component: Sgke320dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke330d', component: Sgke330dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke340d', component: Sgke340dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke350d', component: Sgke350dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke360d', component: Sgke360dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke370d', component: Sgke370dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke380d', component: Sgke380dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke390d', component: Sgke390dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke400d', component: Sgke400dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgke410d', component: Sgke410dComponent, canDeactivate: [BrowserBackGuard] },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SgKeMainRoutingModule { }